<template>
  <div class="new-block new-block_cover">
    <div class="new-block-image">
      <div class="image image_cover full-width">
        <img :src="cover" v-if="cover" />
        <svg class="new-loader" v-if="loading && !cover" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
            <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
              <animateTransform 
                attributeName="transform" 
                attributeType="XML" 
                type="rotate"
                dur="1s" 
                from="0 50 50"
                to="360 50 50" 
                repeatCount="indefinite" />
          </path>
        </svg>
        <div class="image-panel">
          
          <div class="image-panel__item">
            <input
              class="new-block-image__input"
              type="file"
              multiple
              @change="readFile"
              name="myImage"
              max-size="5000"
              accept="image/*"
            />
            <font-awesome-icon icon="image" style="font-size: 34px" />
          </div>
          <div class="image-panel__item" @click="deleteImage()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 24 24">
              <path
                d="M17 22H7a2 2 0 01-2-2V7H3V5h4V4a2 2 0 012-2h6a2 2 0 012 2v1h4v2h-2v13a2 2 0 01-2 2zM7 7v13h10V7H7zm2-3v1h6V4H9zm6 14h-2V9h2v9zm-4 0H9V9h2v9z"
              />
            </svg>
          </div>
        </div>
      </div>

      <!-- Добавить изображение -->
      <div class="new-block-image__add" v-if="!loading && !cover">
        <input
          class="new-block-image__input"
          type="file"
          multiple
          @change="readFile"
          name="myImage"
          max-size="10000"
          accept="image/*"
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="#2E3A59"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            d="M5 6.41L10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41 17.59 5 12 10.59 6.41 5 5 6.41z"
          />
        </svg>
        <p>Добавить обложку (до 10MB)</p>
      </div>
    </div>
  </div>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {faImage} from '@fortawesome/free-solid-svg-icons';

library.add(
  faImage
);

export default {
  name: 'Block',
  data: () => {
    return {
      cover: null,
      loading: false
    };
  },
  props: {
    active_cover: {
      type: String,
      require: false,
    },
    path: {
      type: String,
      require: false,
      default: "other"
    }
  },
  computed: {
    getNewType() {
      return this.$store.getters.getNewType;
    }
  },
  methods: {
    showImageChange(type) {
      let result = true;
      !this.addMore ? type === 'image' ? '' : result = false : '';
      return result
    },
    changeCover() {
      this.$emit('changeCover', this.cover);
    },
    readFile(input) {
      let element = input.target.files[0];
        if (element.size / 1024 > 10000) {
        this.$store.dispatch('addError', {message: 'Размер одной из фотографий превышает 8MB'});
        } else {
        var reader = new FileReader();
        reader.readAsDataURL(element)
        reader.onload = async () => {
            let url = reader.result;
            let type = element.type.split('/')[1];
            let size = element.size / 1024;
            let name = this.$moment().format('ss-mm-HH_DD-MM-YYYY') + '_' + Math.round(Math.random() * 1000);
            let path = this.path || "other";
            this.loading = true;
            await this.$store.dispatch('uploadImage', {url, type: type || 'jpeg', name, size, path, resize: 1200})
            .then(response => {
                response.Location 
                  ? (this.cover = response.Location, this.changeCover()) 
                  : (this.cover = null, this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'}));
                this.loading = false;
            }).catch(() => {
                this.loading = false;
                this.cover = null;
                this.changeCover();
                this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'})
            });
        };

        reader.onerror = function() {
            this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
        };            
        }
    },
    async deleteImage() {
      await this.$store.dispatch('deleteImage', {key: this.cover})
      this.cover = null
      this.changeCover()
    }
  },
  watch: {
    active_cover(active) {
      this.cover = active
    }
  },
  mounted() {
    this.active_cover ? this.cover = this.active_cover : null
  }
}; 
</script>
